/* eslint-disable */
var baseApiUrl = ''
if (process.env.NODE_ENV === 'production') {
  // This will be replaced with the server endpoint for demo purposes
  baseApiUrl = 'https://jbr-api.geodemosolutions.com/public/'
 }
else {
  baseApiUrl = 'http://localhost/login-api/public/'
  // baseApiUrl = 'http://localhost:8000/'

}

export {
  baseApiUrl
}
